/**
 * 화면 덩어리(lazy 청크)를 받는 동안 보여 주는 가벼운 표시.
 * 관리자·매니저 첫 진입에서 청크가 올 때까지 빈 화면이 보이지 않게 한다.
 */
export const RouteLoading = () => (
  <div
    role="status"
    aria-label="불러오는 중"
    className="flex min-h-screen items-center justify-center"
  >
    <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-gray-500" />
  </div>
);
